import { useOrgUser } from '@cibo/profile'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import { UserDrawField } from '../../../components/DrawField'
import { BreadcrumbNavigation } from '../../../components/ImpactLayout'
import { useParamAsInteger } from '../../../consts/Theme'
import { ADMIN_ROUTES } from '../../../navigation/types'
import { LAND_MANAGER_ROUTES } from '../../../navigation/types/routes'

export const AdminDrawField = () => {
  const { t } = useTranslation('impact/UserProfile')
  const userId = useParamAsInteger('userId')
  const user = useOrgUser(userId)
  return (
    <>
      <BreadcrumbNavigation
        breadcrumbs={[
          {
            name: user.data?.displayNameFull || t('user'),
            to: generatePath(ADMIN_ROUTES.USER_FIELDS, { userId: userId?.toString() }),
          },
          {
            name: t('fields'),
            to: generatePath(ADMIN_ROUTES.USER_FIELDS, { userId: userId?.toString() }),
          },
          { name: t('addFields') },
        ]}
      />
      <UserDrawField
        completeRoute={ADMIN_ROUTES.USER_FIELDS}
        profilingRoute={LAND_MANAGER_ROUTES.PROFILE_FIELDS}
        enrollRoute={ADMIN_ROUTES.USER_DETAIL}
      />
    </>
  )
}
